export enum EntityType {
  RULE = 'RULE',
}

export default class BusinessHoursReference {
  id: string;
  name: string;
  type: EntityType;
}
